/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module table
 */

import Table from './table';
import TableToolbar from './tabletoolbar';
import TableCellProperties from './tablecellproperties';
import TableProperties from './tableproperties';
import TableClipboard from './tableclipboard';
import TableMouse from './tablemouse';
import TableKeyboard from './tablekeyboard';
import TableSelection from './tableselection';
import TableUtils from './tableutils';

export default {
	Table,
	TableToolbar,
	TableCellProperties,
	TableProperties,
	TableMouse,
	TableClipboard,
	TableKeyboard,
	TableSelection,
	TableUtils
};
